import { IntlShape } from 'react-intl';

import { Messages } from '../Services/I18n/typings/LocalMessageActionTypes';

export class MessageUtils {
    public static isEmpty = (messages: Messages): boolean => {
        return Object.keys(messages).length === 0;
    };

    public static checkEmptyField = (
        field: string,
        value: any,
        messages: Messages,
        errorMessage: string
    ): void => {
        if (!value) {
            messages[field] = errorMessage;
        }
    };

    public static get = (messageProvider: IntlShape, id: string): string => {
        return messageProvider.formatMessage({ id });
    };
}
